import React, { useEffect, useState } from "react";
import { Button } from "../ui/button";
import { Link } from "react-router-dom";
import ThirdPartyCookieInfo from "./ThirdPartyCookieInfo";
import Image from "../Tags/Image";
import { Switch } from "../ui/switch";
import { Badge } from "../ui/badge";

export default function Login() {
  const isBetaEnv = process.env.REACT_APP_ENV_NAME === "beta";
  const [isBetaUser, setIsBetaUser] = useState(isBetaEnv);
  const handleBetaToggle = (value) => {
    if (typeof window !== "undefined" && window.parent) {
      window.parent.postMessage(
        {
          type: "IS_BETA_USER",
          isBetaUser: value,
        },
        "*"
      );
    }
  };

  return (
    <>
      <ThirdPartyCookieInfo />
      <div className="w-full p-10 pt-48">
        <div className="flex justify-center items-center flex-col">
          <Image
            className="no-invert"
            src={`/images/ext/logo/${process.env.REACT_APP_APP_LOGO}.svg`}
            alt="Logo"
          />
          {isBetaEnv && (
            <div className="mt-8 w-[260px] rounded-xl border border-border bg-muted/40 px-4 py-3 shadow-sm">
              <div className="flex items-center justify-between">
                <span className="text-sm font-semibold text-foreground">
                  I am a <Badge className="bg-black text-white">beta</Badge> user
                </span>
                <Switch checked={isBetaUser} onCheckedChange={handleBetaToggle} />
              </div>
            </div>
          )}
          <div className="space-y-3 mt-14">
            <Button variant="outline" asChild className="w-[165px] bg-background text-gray-800 flex">
              <Link target="_blank" to={`${process.env.REACT_APP_API_BASE_URL}/login/google`}>
                <Image src="/images/ext/google.svg" alt="Google" className="mr-2 no-invert" />
                Log in with Google
              </Link>
            </Button>
            <Button variant="outline" asChild className="w-[165px] bg-background text-gray-800 flex">
              <Link target="_blank" to={`${process.env.REACT_APP_API_BASE_URL}/login/slack`}>
                <Image src="/images/ext/slack.svg" alt="Slack" className="mr-2 no-invert" /> Log in with Slack
              </Link>
            </Button>
            <Button variant="outline" asChild className="w-[165px] bg-background text-gray-800 flex">
              <Link
                target="_blank"
                to={`${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_APP_HOME}/login`}
              >
                <Image src="/images/ext/envelope.svg" alt="Email" className="mr-2 no-invert" /> Log in with
                Email
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
